import FilterButton from '@components/button/FilterButton'
import ElementShowcase from '@components/element/ElementShowcase'
import Column from '@components/layout/Column'
import Icon from '@components/svg/SearchSvg'
import useMediaQuery, { maxWidthQueries, minWidthQueries } from '@operations/utils/useMediaQuery'
import React, { useRef } from 'react'
import styled from 'styled-components'

import DynastyFilter from './DynastyFilter'
import { SearchFieldButton } from './SearchForm'

const StyledAdvancedSearch = styled.div`
  max-height: ${({ active, maxHeight }) => (active ? maxHeight : 0)};
  transition: all 0.2s ease;
  overflow: hidden;
  width: 100%;
  padding: ${({ active }) => (active ? '1rem' : 0)};
  background: ${({ theme }) => theme.colors.whiteSmoke};
  ${({ active, theme }) => active && `border: 1px solid ${theme.colors.lightGrey}`};
  margin-bottom: ${({ active }) => (active ? '1rem' : 0)};
`
const AdvancedSearchForm = styled.form`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
`
const AdvancedSearchFieldButton = styled(SearchFieldButton)`
  display: flex;
  align-items: center;
  height: auto;
  margin: 0.5rem 0.5rem 0.5rem 0;
  font-size: ${({ theme }) => theme.font.fontSize.regular};
  svg {
    margin-right: 0.25rem;
    fill: ${({ theme }) => theme.colors.white};
  }
`
const AdvancedSearchActionsWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${AdvancedSearchFieldButton} {
    margin-right: 1rem;
  }
`
const ElementsList = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0 1% 0.5rem 0;
  @media ${minWidthQueries.md} {
    width: 60%;
  }
`
const SizeList = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 1rem;
  @media ${minWidthQueries.md} {
    width: 60%;
    margin-bottom: 0;
  }
`
const SizeWrap = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
`
const SizeRefButton = styled.button`
  background-color: ${({ theme, active }) =>
    active ? theme.colors.lightGrey : theme.colors.white};
  width: calc(33% - 0.5rem);
  border: 1px solid ${({ theme }) => theme.colors.black};
`
const MiscList = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 1rem;
  @media ${minWidthQueries.md} {
    width: 60%;
    margin-bottom: 0;
  }
`
const MiscListWrap = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1rem;
  width: 100%;
  flex-wrap: wrap;
`
const ElementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
`
const BottomMargin = styled.div`
  margin-bottom: 2rem;
`
const AdvancedSearchButtonRound = styled.div`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: black;
  margin: 20px;
  filter: invert(1);

  animation: bounce 2s infinite;
  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(30px);
    }
    60% {
      transform: translateY(15px);
    }
  }
  &:hover {
    cursor: ${({ theme }) => theme.cursor.pointer};
    background: rgba(215, 215, 215, 0.45);
  }
`
const RotatedArrow = styled.img`
  transform: rotate(90deg);
`
const AdvancedSearch = ({
  isActive,
  setIsActive,
  onSubmit,
  elementsList,
  handleElementChange,
  elementValue,
  sizeReference,
  handleSizeRefChange,
  rarityList,
  setRarityValue,
  rarityValue,
  natureValue,
  setNatureValue,
  clearSearch,
  dynastiesList,
  handleDynastyChange,
  dynastyValue,
  randomSentius,
}) => {
  const isMobile = useMediaQuery(maxWidthQueries.sm)
  const isActiveRef = useRef(isActive)

  const rotateArrow = () => {
    if (isActive) {
      console.log('rotate')
      isActiveRef.current.style.transform = 'rotate(90deg)'
    } else {
      console.log('rotate')
      isActiveRef.current.style.transform = 'rotate(-90deg)'
    }
  }

  return (
    <>
      <StyledAdvancedSearch active={isActive} maxHeight={isMobile ? '1500px' : '900px'}>
        <AdvancedSearchForm
          onSubmit={e => {
            e.preventDefault()
            onSubmit(e)
          }}
        >
          <ElementWrapper>
            <ElementsList>
              <h3>Element</h3>
              <ElementShowcase
                colSize="calc(33% - .5rem)"
                elements={elementsList}
                iconHeight="auto"
                iconWidth="60px"
                justify="flex-start"
                marginBottom=".5rem"
                selected={elementValue}
                onClick={e => handleElementChange(e)}
              />
            </ElementsList>
          </ElementWrapper>
          <SizeList>
            <h3>Size</h3>
            <SizeWrap>
              <SizeRefButton
                active={sizeReference === 'small'}
                type="button"
                onClick={() => handleSizeRefChange('small')}
              >
                <img alt="sentius size filter - small" src="/images/small_sentius.png" />
              </SizeRefButton>
              <SizeRefButton
                active={sizeReference === 'medium'}
                type="button"
                onClick={() => handleSizeRefChange('medium')}
              >
                <img alt="sentius size filter - medium" src="/images/medium_sentius.png" />
              </SizeRefButton>
              <SizeRefButton
                active={sizeReference === 'large'}
                type="button"
                onClick={() => handleSizeRefChange('large')}
              >
                <img alt="sentius size filter - large" src="/images/large_sentius.png" />
              </SizeRefButton>
            </SizeWrap>
          </SizeList>
          <MiscList>
            <MiscListWrap>
              <Column
                align="flex-start"
                direction="column"
                margin={isMobile ? '0 0 10px' : '20px 0'}
                width={isMobile ? '100%' : '33%'}
              >
                <h3>Rarity</h3>
                {rarityList?.length > 0 &&
                  rarityList?.map(rarity => (
                    <FilterButton
                      key={rarity.id}
                      active={rarityValue === rarity.slug}
                      type="button"
                      onClick={() =>
                        rarityValue === rarity.slug
                          ? setRarityValue('')
                          : setRarityValue(rarity.slug)
                      }
                    >
                      {rarity.name}
                    </FilterButton>
                  ))}
              </Column>
              <Column
                align="flex-start"
                direction="column"
                margin={isMobile ? '0 0 10px' : '20px 0'}
                width={isMobile ? '100%' : '33%'}
              >
                <h3>Nature</h3>
                <FilterButton
                  active={natureValue === 'passive'}
                  type="button"
                  onClick={() =>
                    natureValue === 'passive' ? setNatureValue('') : setNatureValue('passive')
                  }
                >
                  Passive
                </FilterButton>
                <FilterButton
                  active={natureValue === 'neutral'}
                  type="button"
                  onClick={() =>
                    natureValue === 'neutral' ? setNatureValue('') : setNatureValue('neutral')
                  }
                >
                  Neutral
                </FilterButton>
                <FilterButton
                  active={natureValue === 'aggressive'}
                  type="button"
                  onClick={() =>
                    natureValue === 'aggressive' ? setNatureValue('') : setNatureValue('aggressive')
                  }
                >
                  Aggressive
                </FilterButton>
              </Column>
              <Column
                align="flex-start"
                direction="column"
                margin={isMobile ? '0 0 10px' : '20px 0'}
                width={isMobile ? '100%' : '33%'}
              >
                <DynastyFilter
                  dynastiesList={dynastiesList}
                  dynastyValue={dynastyValue}
                  handleDynastyChange={handleDynastyChange}
                />
              </Column>
            </MiscListWrap>
          </MiscList>
        </AdvancedSearchForm>
        <BottomMargin />
      </StyledAdvancedSearch>

      {/* Search, reset search,*random sentius */}
      <AdvancedSearchActionsWrap
        style={{
          background: '#f5f5f5',
          border: '1px solid #d3d3d3',
          boxShadow: '-5px 5px 5px black',
          padding: '1rem',
        }}
      >
        <AdvancedSearchFieldButton type="submit" onClick={() => onSubmit()}>
          <Icon /> Search
        </AdvancedSearchFieldButton>
        <AdvancedSearchFieldButton type="button" onClick={() => clearSearch()}>
          Reset search
        </AdvancedSearchFieldButton>
        <AdvancedSearchFieldButton
          style={{ background: '#00e1ff', border: '1px solid #00e1ff' }}
          type="button"
          onClick={() => randomSentius()}
        >
          Random Sentius{' '}
        </AdvancedSearchFieldButton>
      </AdvancedSearchActionsWrap>

      {/* ADVANCED SEACH BUTTON
      < AdvancedSearchFieldButton onClick={() => setIsActive(!isActive)}>
        {isActive ? 'Hide' : 'Show'} advanced search
      </AdvancedSearchFieldButton >
      */}
      <AdvancedSearchButtonRound
        onClick={() => {
          setIsActive(!isActive)
          rotateArrow()
        }}
      >
        <RotatedArrow ref={isActiveRef} alt="search icon arrow" src="./images/arrow.png" />
      </AdvancedSearchButtonRound>
    </>
  )
}

export default AdvancedSearch
